import { Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { MobAbstractService } from '~/services/api/web/mobs/mobAbstractService';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { ResponseModel } from '~/models/responseModel';
import { MobModel } from '~/models/mobModel';
import { Observable } from 'rxjs';
import { ClipModel } from '~/models/clipModel';
import { map as _map } from 'lodash';
import { MobRelatedItemsModel } from '~/models/mobRelatedItemsModel';
import { InventoryClipModel } from '~/models/inventoryClipModel';
import { InventoryBaleModel } from '~/models/inventoryBaleModel';
import { InventorySpecieModel } from '~/models/inventorySpecieModel';
import { InsightModel } from '~/models/insightModel';
import { MobBreakDownModel } from '~/models/breakDownModel';
import { InventoryMobModel } from '~/models/inventoryMobModel';
import { EntityModel } from '~/models/entityModel';
import { BaleSummaryModel } from '~/models/baleSummaryModel';
import { SpeciSummaryModel } from '~/models/speciSummaryModel';
import { ClipSummaryModel } from '~/models/clipSummaryModel';

@Injectable()
export class MobService extends BaseWebService implements MobAbstractService {

    public static readonly PATH:string = '/mobs';

    constructor(http: HttpClientWrapper) {
        super(http);
    }

    public getMobs(entity?: EntityModel): Observable<ResponseModel> {
        let url:string = MobService.URL + MobService.PATH ;
        let params = new HttpParams();
        
        if (entity.entityId) {
            params = params.append('entityId', entity.entityId.toString());
        }

        let options:{} = {
            params: params
        };

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new InventoryMobModel(mob));
        });
    }

    public getMobById(mobId: number): Observable<ResponseModel> {
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString();

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new InventoryMobModel(response['data']);
        });
    }

    public getBalesByMobId(mobId:number){
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString() + '/bales';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new BaleSummaryModel(mob));
        });
    }

    public getSpecisByMobId(mobId:number){
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString() + '/specis';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new SpeciSummaryModel(mob));
        });
    }

    public getClipsByMobId(mobId:number){
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString() + '/clips';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new ClipSummaryModel(mob));
        });
    }

    public getMobInsight(mobId:number): Observable<ResponseModel> {
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString() + '/insight';

        let options:{} = {};

        return this.http.get(url, options, (response:HttpResponse<any>) => {
            return new InsightModel(response['data']);
        });
    }

    public getWooltypeByMob(mobId: number): Observable<ResponseModel> {
        let url:string = MobService.URL + MobService.PATH + '/' + mobId.toString() + '/balesbywooltype';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (inventoryMob:{}) => new MobBreakDownModel(inventoryMob));
        });
    }
}
